// ----------------------------
// Created by Bulletproof Games
//            2017
//  www.bulletproofgames.co.uk
// ----------------------------

///////////////////////////
// Tiki Runner game //
///////////////////////////
gameData = {};
gameData.baseGameRecStakeIdx = -1;

game = (function () {
  var _gameName = 'Fat Cats DoubleMax™';
  var _gameVersionMajor = '1';
  var _gameVersionMinor = '0';
  var _gameVersionBugFix = '2';
  let _gameReleaseDate = '23/09/2026';

  ///////////////////////
  // Developer options //
  ///////////////////////

  // Reflex.enableDeveloperMode();
  //Reflex.developerModeData.checkUnusuedResources = true;
  // Reflex.developerModeData.useLogFiles= true;
  // Reflex.developerModeData.logFileIP= "192.168.1.106";
  // Reflex.developerModeData.highlightTranslatedText = true;
  //Reflex.developerModeData.canBreakInjectorRules = true;
  //Reflex.developerModeData.createTestLanguages = true;
  // Reflex.developerModeData.showButtonHitAreas = true;
  // bowser.mobile = true;

  ///////////////////////
  ///////////////////////

  gameData.gameNameShort = 'FCD';
  gameData.gameVersionMajor = _gameVersionMajor;
  gameData.gameVersionMinor = _gameVersionMinor;
  gameData.gameVersionBugFix = _gameVersionBugFix;
  gameData.gameReleaseDate = _gameReleaseDate;
  gameData.version = '' + _gameVersionMajor + '.' + _gameVersionMinor + '.' + _gameVersionBugFix;

  function createVersion() {
    var versionString = _gameName + ' v' + _gameVersionMajor + '.' + _gameVersionMinor + '.' + _gameVersionBugFix;
    Debug.log(versionString);
  }

  function initialise(gameConfigTask) {
    // Store game configuration
    gameData.gameConfig = gameConfigTask.data;

    createVersion();
    slotMachine.selectReelMode('standard');

    gameData.expandIndices = {
      top: 0,
      bottom: 8,
    };
    gameData.contractIndices = {
      top: 5,
      bottom: 8,
    };

    gameData.gameMathsVersion = gameConfigTask.data.mathsVersion;

    // All objects are created, so create game specific data
    // for (var i = 0; i < slotMachine.reels.length; i++) {
    // 	var reel = resourceManager.get("slotContainer:reelContainer:reel" + i);
    // 	var startingSymbols = gameData.slotConfig.startingSymbols[i].symbols;

    // 	// Copy starting symbols from server
    // 	var apperatureSize = (reel.configParams.totalAppertureSize - (reel.configParams.preappertureSymbols + reel.configParams.postappertureSymbols));
    // 	for (var j = 0; j < apperatureSize; ++j) {
    // 		reel.setReelSymbol(j, startingSymbols[j].value);
    // 	}
    // 	for (var j = 1; j <= reel.configParams.preappertureSymbols; ++j) {
    // 		reel.setReelSymbol(-j, reel.preInjector.base.getValidSymbol([], reel.symbolData, 0));
    // 	}
    // 	for (var j = 0; j < reel.configParams.postappertureSymbols; ++j) {
    // 		reel.setReelSymbol((apperatureSize + j), reel.preInjector.base.getValidSymbol(reel.symbolData, [], 0));
    // 	}
    // 	// using a closure to pass through the correct reelID
    // 	reel.spinCompleteCallback = (function() {
    // 		var reelID = i;
    // 		return function() {
    // 			if (freespins.inFreespins) {
    // 				freespins.onSpinComplete(reelID);
    // 			} else {
    // 				gameController.onSpinComplete(reelID);
    // 			}
    // 		};
    // 	})();
    // }
    // 	gameData.reels.push(reel);
    //console.log("Dont forget the home button");
    gameData.stakes = [];
    gameData.currentStakeIndex = gameConfigTask.data.slotConfig.coinSizes.indexOf(
      gameConfigTask.data.slotConfig.defaultAmountPerLine
    );

    for (i = 0; i < gameConfigTask.data.slotConfig.coinSizes.length; i++) {
      gameData.stakes.push(
        gameConfigTask.data.slotConfig.coinSizes[i] * gameConfigTask.data.slotConfig.defaultNumLines
      );
      //gameData.coinSizes.push(gameConfigTask.data.slotConfig.coinSizes[i]);
    }

    let stakeController = resourceManager.getController('stakeController');
    if (gameData.recoveryStake) {
      gameData.baseGameRecStakeIdx = gameData.currentStakeIndex;
      game.changeStake(gameData.recoveryStake);
    } else {
      game.changeStake(stakeController.Stakes[gameData.currentStakeIndex]);
    }

    gsap.registerPlugin(PixiPlugin);
  }

  function backFromReplay(data) {
    if (
      soundManager.sharedMode === true // we have been sharing the soundManager
    ) {
      // im going to assume the back button has been pressed during watching a replay
      // the ygg platform is telling us to unmute audio
      // stop any sounds currently playing from the old replay game
      // then clear the sharedMode flag
      // we need to restore what audio and what levels they were playing at
      // this will be down to each client to handle this as ids are stored all over the place
      // the music managers are inconsistant
      soundManager.stopAllSounds();
      soundManager.sharedMode = false;
      messageBus.post('sounds:restorePreviouslyPlayingAudio', {
        reason: 'back from replay',
      });
    }
  }

  function onModal(data) {}

  function onReelInteraction(reel, row) {
    console.log('Clicked on Reel' + reel + ', Symbol ' + row);

    // Animate the symbol at that position
    var animation = {
      type: 'Symbol',
      slotMachine: undefined,
      sound: 'symbol_Ten',
      data: [
        {
          multiplier: 1,
          reel: reel,
          row: row,
          symbolIndex: gameData.reels[reel].getSymbol(row),
          value: 0,
        },
      ],
    };
    tikiRunnerSymbolAnimator.playAnimation(animation, function () {});
  }

  function dimAllSymbols(dim, tint) {
    for (var i = 0; i < reelManager.reels.length; i++) {
      reelManager.reels[i].dimAllSymbols(dim, tint);
    }
  }

  function onCloseTutorial() {
    messageBus.postImmediate('game:onCloseTutorial');

    resourceManager.getContainer('loadingContainer').visible = false;

    resourceManager.getContainer('backgroundContainer').visible = true;

    const bgContainer = resourceManager.getContainer('backgroundContainer');
    bgContainer.visible = true;
    gameData.gameMask = new PIXI.Graphics();
    gameData.gameMask.beginFill(0xffffff);
    gameData.gameMask.lineStyle(0, 0xffffff);
    gameData.gameMask.drawRect(0, 0, 1, 1);
    bgContainer.addChild(gameData.gameMask);

    systemData.gameContainer.mask = gameData.gameMask;

    //resourceManager.get("freespinsBackground").visible = false;
    //resourceManager.get("freespinsBackground720").visible = false;

    gameData.winningsText = resourceManager.get('winningsText');

    resourceManager.getContainer('soundTrack').visible = false;

    // helper.updateHelpWinlineText();

    // Initialise winline plugin
    winlineFadeAnimator.initialise();

    if (!Reflex.developerMode && gdk.deviceInfo.mobile && !gdk.isFullscreen()) {
      gdk.requestFullscreen();
    }

    if (gdk.deviceInfo.chrome && gdk.deviceInfo.android) {
      var chromeVersion = Number(
        String(gdk.deviceInfo.version).substring(0, String(gdk.deviceInfo.version).indexOf('.'))
      );
      if (chromeVersion >= 55) {
        // Chrome will only start audio on a touch
        Howler.ctx.resume();
      }
    }

    // Set up character either behind or in front of message bar
    gameData.gameContainer = resourceManager.getContainer('gameContainer');
    onResize();

    resourceManager.getContainer('loadingContainer').visible = false;
    resourceManager.getContainer('gameContainer').visible = true;
    resourceManager.getContainer('msgBoxPopupContainer').visible = true;
    resourceManager.getContainer('winningsTextContainer').visible = true;
    resourceManager.getContainer('gameButtonContainer').visible = true;
    resourceManager.getContainer('particleContainer').visible = true;
    resourceManager.getContainer('helpPageScroll').visible = true;

    resourceManager.getContainer('buyABonusContainer').visible = true;
    resourceManager.getContainer('settingsMenuContainer').visible = true;

    Reflex.registerEventHandler('devicePerformance', function (capability, gamePerformance) {
      resourceManager.devicePerformance = gamePerformance;
      setupPerformanceDependentObjects();
    });

    let license = gameData.license.toUpperCase();

    if (license === 'BR') {
      resourceManager.get('buttonContainer:buttonBar:autoplayButton:glow').visible = false;
      resourceManager.get('helpScrollContainer:helpPageScroll').open();
    }

    //encoreEffect.showOpeningPopup(true);

    gameData.inputOverlord.setState('enabled');

    gameController.initialise();
  }

  function enableEncore(enabled) {
    gameData.encoreEnabled = enabled;
  }

  function setupPerformanceDependentObjects() {
    // Performance meter has not yet been issued
    if (checkForUndefined(resourceManager.devicePerformance)) return;

    if (resourceManager.devicePerformance >= 80) {
      // High performance dependent objects go here (80-100)
    }

    if (resourceManager.devicePerformance >= 60) {
      // Medium performance dependent objects go here (60-100)
      //resourceManager.get("background").filters = [game.reflectionShader];
      /*timerManager.addTimer(3000,
				function(progress) {game.reflectionShader.uniforms.strength = progress * 0.3;},
				function() { game.reflectionShader.uniforms.strength = 0.3; } );
				*/
    }

    if (resourceManager.devicePerformance >= 40) {
      // Low performance dependent objects go here (40-100)
    }

    if (resourceManager.devicePerformance < 40) {
      // Minimum spec goes here (1 to 39)
    }
  }

  function blurGame(enable, value) {
    if (resourceManager.selectedAssetResolution.name === 'standard') {
      value = checkForDefined(value) ? value : 1;
      resourceManager.getContainer('gameContainer').filters = enable ? [new PIXI.filters.BlurFilter(value)] : [];
      resourceManager.getContainer('gameButtonContainer').filters = enable ? [new PIXI.filters.BlurFilter(value)] : [];
    }
  }

  function changeStake(selectedStake, bpl) {
    if (gameData.stakeMeter.value != selectedStake) {
      gameData.stakeMeter.set(selectedStake);
      gdk.playerChangedStake(selectedStake);
    }
  }

  function creditChanged(creditTask) {
    let credit = creditTask.data.balance;
    if (
      gdk.serverParser._inReplayMode === true &&
      gdk.serverParser._endGame === true &&
      gdk.serverParser.prepaidResultBalance !== 0
    ) {
      // SHOULDNT NEED THIS IF YGG FIXED THERE STUFF
      credit = gdk.serverParser.prepaidResultBalance;
    }
    gameData.credit = credit;
    gameData.creditMeter.set(credit);
  }

  function onLoaded(loader, res) {
    //var container = resourceManager.get("background");
    //var uniforms = { time:  {type:"f", value:0.0}, strength: {type:"f", value:0.0}, width: {type:"f", value:container.scale.x}, height: {type:"f", value:container.scale.y}, boundary: {type:"f", value:0.9} };
    //game.reflectionShader = new PIXI.Filter(null, res.shader.data, uniforms);
    setupPerformanceDependentObjects();
  }

  function onOrientationChange() {}

  function goToSplash() {
    messageBus.postImmediate('game:goToSplash');
    var loadingData = gdk.getPlatformLoadingData();
  }

  function onResize() {
    if (gameData.gameMask) {
      if (systemData.isLandscape) {
        gameData.gameMask.scale.x = 1280;
        gameData.gameMask.scale.y = 720;
      } else {
        gameData.gameMask.scale.x = 720;
        gameData.gameMask.scale.y = 1280;
      }
    }

    if (checkForDefined(game.reflectionShader)) {
      //var container = resourceManager.get("background");
      game.reflectionShader.uniforms.width = Reflex.scaleX;
      game.reflectionShader.uniforms.height = Reflex.scaleY;
    }
  }

  function onReady() {
    var numSymbols = Object.keys(resourceManager.getConfiguration().symbols).length;

    // Set up symbol creation callbacks
    var slotMachine = slotMachineFactory.getSlotMachine(0);
    for (var i = 0; i < numSymbols; ++i) {
      slotMachine.symbolCreationCallbacks[i.toString()] = helper.getSymbolChildrenDescriptions;
    }

    for (var i = 0; i < 5; i++) {
      slotMachine.reels[i].setAnySymbolCreatedCallback(helper.symbolCreationCallback);
    }

    symbolGlowManager.initialise();
  }

  function update(delta) {
    if (checkForDefined(game.reflectionShader)) {
      game.reflectionShader.uniforms.time += delta / 1000;
    }
  }

  function enableSpeedUp() {
    const caller = new Error().stack?.split('\n')[2]?.trim().split(' ')[1];
    if (caller === 'GDK.readyCb') {
      document.addEventListener('keydown', (event) => {
        let validOptionPressed = true;
        if (typeof _timeScale === 'undefined') {
          _timeScale = 1;
        }
        if (event.key === '+') {
          _timeScale += 0.1;
        } else if (event.key === '=') {
          _timeScale += 0.1;
        } else if (event.key === '_') {
          _timeScale -= 0.1;
        } else if (event.key === '-') {
          _timeScale -= 0.1;
        } else if (event.key === '*') {
          _timeScale *= 2;
        } else if (event.key === '/') {
          _timeScale /= 2;
        } else if (event.key === '0') {
          _timeScale = 0;
        } else if (event.key === '1') {
          _timeScale = 1;
        } else if (event.key === '2') {
          _timeScale = 2;
        } else if (event.key === '3') {
          _timeScale = 3;
        } else if (event.key === '4') {
          _timeScale = 4;
        } else if (event.key === '5') {
          _timeScale = 5;
        } else if (event.key === '6') {
          _timeScale = 6;
        } else if (event.key === '7') {
          _timeScale = 7;
        } else if (event.key === '8') {
          _timeScale = 8;
        } else if (event.key === '9') {
          _timeScale = 9;
        } else {
          validOptionPressed = false;
        }

        if (validOptionPressed) {
          if (_timeScale > 10) _timeScale = 10;
          if (_timeScale < 0) _timeScale = 0;

          setSpeed(_timeScale);
        }
      });
    }
  }

  function setSpeed(speed) {
    // not sure this is needed here!
    // if (Reflex.gamePaused || Reflex.platformPaused) {
    //   soundManager.pauseAllSounds();
    // } else {
    //   soundManager.resumeAllSounds();
    // }
    soundManager.setTimeScale(speed);
    gsap.globalTimeline.timeScale(speed);
    Reflex.setGameSpeed(speed);
  }

  // define game object to be returned
  var game = {};

  Object.defineProperties(game, {
    enableSpeedUp: {
      value: enableSpeedUp,
    },
    enableEncore: {
      value: enableEncore,
    },
    onCloseTutorial: {
      value: onCloseTutorial,
    },
    initialise: {
      value: initialise,
    },
    blurGame: {
      value: blurGame,
    },
    changeStake: {
      value: changeStake,
    },
    dimAllSymbols: {
      value: dimAllSymbols,
    },

    goToSplash: {
      value: goToSplash,
    },
  });

  ///////////////////
  // subscriptions //
  ///////////////////

  messageBus.subscribe('common:BalanceEvent', creditChanged);
  messageBus.subscribe('stake:stakeChanged', changeStake);
  messageBus.subscribe('game:modal', onModal);
  Reflex.registerEventHandler('orientationChange', onOrientationChange);
  Reflex.registerEventHandler('ready', onReady);
  Reflex.registerEventHandler('resize', onResize);
  Reflex.addToUpdate(update);
  messageBus.subscribe('game:backFromReplay', backFromReplay);

  // this should go in the libs, but i have overridden here
  // and it will try and use setLoadProgress 1st
  resourceManager.onLoadComplete = function (delayInMS) {
    const duration = typeof delayInMS === 'number' && delayInMS > 0 ? delayInMS : 1000;
    const tag = toString.call(Loader.setLoadProgress);
    const isFunc = tag === '[object Function]' || tag === '[object AsyncFunction]';
    if (isFunc) {
      Loader.setLoadProgress(1);
    } else {
      if (Loader?.loadMask?.scale) {
        Loader.loadMask.scale.x = 1;
      }
      if (Loader?.progressBar?.scale) {
        Loader.progressBar.scale.x = 1;
      }
    }

    window.setTimeout(() => {
      for (let i = 0; i < resourceManager.loadCompleteCallbacks.length; i++) {
        resourceManager.loadCompleteCallbacks[i]('Creating Resources');
      }
      // Art and sounds have now been loaded, and we have pre created movies
      resourceManager.onEverythingLoaded();
    }, duration);
  };

  timerManager.delayAsync = async function (time, tickCallback, completeCallback, data) {
    if (!tickCallback) {
      tickCallback = (progress) => {};
    }
    if (!completeCallback) {
      completeCallback = () => {};
    }
    // cant expire it early at the moment!!!!!
    let resolver = null;
    const promise = new Promise((resolve) => {
      resolver = resolve;
    });

    const completeCB = () => {
      completeCallback();
      resolver();
    };

    const timer = timerManager.addDelayedTimer(0, time, tickCallback, completeCB, data);

    await promise;
  };

  return game;
})();
